<template>
  <div class="card mb-3 h-100">
    <div class="card-header">
      <h5 class="mb-0">{{ title }}</h5>
    </div>
    <div class="card-body">
      <div v-if="available">
        <slot></slot>
      </div>
      <div v-else class="text-center py-4">
        <p class="text-muted mb-1">Not yet available</p>
        <p class="text-muted small mb-0" v-if="unavailableReason">{{ unavailableReason }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  available: { type: Boolean, default: true },
  unavailableReason: { type: String, default: '' },
});
</script>
